<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-12.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-sync"
          :text="$t('ui.refresh')"
          type="button"
          @click="getPaymentOptionList(true)"
          variant="primary"
          size="sm"
        )
  .card-body
    .row
      //- .col-12
      //-   .alert.alert-warning.alert-sm.p-1 {{ $t('message.tooltips_payment_setting') }}
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="3%")
                  span #
                th(width="7%")
                  span(:title="$t('ui.mode')") {{ $t('ui.mode') }}
                th(width="10%")
                  span(:title="$t('ui.description')") {{ $t("ui.description") }}
                th(width="10%")
                  span(:title="$t('ui.bank_id')") {{ $t("ui.bank_id") }}
                th(width="10%")
                  span(:title="$t('ui.bank_acc_no')") {{ $t("ui.bank_acc_no") }}
                th.text-center(width="10%")
                  span(:title="$t('ui.status')") {{ $t("ui.status") }}
                th.text-center(width="10%")
                  span {{ $t('ui.recommend') }}
                th.text-center(width="10%")
                  span {{ $t('ui.sequence') }}
                th.text-center(width="10%")
                  span {{ $t('ui.vip') }}
                th.text-right(width="10%")
                  span {{ $t('ui.limit') }}
                th.text-center(width="10%")
                  span {{ $t('ui.credential') }}
            tbody.clusterize-content
              tr(v-if="paymentOptionList.length == 0")
                td(colspan="11").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in paymentOptionList")
                td.text-center
                  span(:title="index + 1") {{ index + 1 }}
                td
                  span(:title="item.payment_mode") {{ item.payment_mode }}
                td
                  template(v-if="isEditAccess")
                    span(:title="item.payment_desc")
                      a.text-primary.font-weight-bold.text-decoration-none(href="javascript:void(0)" @click="changeDesc(item)" :title="item.payment_desc") {{ item.payment_desc }}
                  template(v-else)
                    span(:title="item.payment_desc") {{ item.payment_desc }}
                td
                  span(:title="item.bank_id") {{ item.bank_id }}
                td
                  span(:title="item.bank_acc_no") {{ item.bank_acc_no }}
                td.text-center
                  div.d-flex.justify-content-center.align-items-center
                    label.custom-switch
                      input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="item.status" @change="isEditAccess ? changedStatus(item, $event) : null" :disabled="!isEditAccess")
                      span.custom-switch-indicator
                td.text-center
                  div.d-flex.justify-content-center.align-items-center(v-if="item.payment_mode != 'MANUAL'")
                    label.custom-switch
                      input.custom-switch-input(type='checkbox' name='custom-switch-checkbox' v-model="item.is_recommend" @change="isEditAccess ? changedRecommend(item, $event) : null" :disabled="!isEditAccess")
                      span.custom-switch-indicator
                td
                  b-form-select.text-center(v-if="item.payment_mode != 'MANUAL'" v-model="item.seq" @change="isEditAccess ? changedSeq(item, $event) : null" size="sm" :disabled="!isEditAccess")
                    option(value=0 disabled) 0
                    option(v-for="index in paymentOptionListLength" :key="index") {{ index }}
                    option(v-if="paymentOptionListLength < 100" :key="100") 100
                td.text-center
                  a.text-decoration-none(v-if="item.payment_mode != 'MANUAL'" href="javascript:void(0)" @click="isEditAccess ? changeVip(item) : null" :title="$t('ui.edit')" :disabled="!isEditAccess")
                    span(:title="item.vip_id") {{ item.vip_id }}
                td.text-right
                  a.text-decoration-none(v-if="item.payment_mode != 'MANUAL'" href="javascript:void(0)" @click="isEditAccess ? changeLimit(item) : null" :title="$t('ui.edit')" :disabled="!isEditAccess")  
                    span.font-weight-bold(:title="$t('ui.min_limit')" :class="$helpers.fontClassName(item.min_limit)") {{ $n(item.min_limit, 'currency') }}
                    br
                    span.font-weight-bold(:title="$t('ui.max_limit')" :class="$helpers.fontClassName(item.max_limit)") {{ $n(item.max_limit, 'currency') }}
                td.text-center
                  //- span(:title="item.credential_1") {{ item.credential_1 }}
                  //- .float-right(v-if="isEditAccess")
                    a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-info(href="javascript:void(0)" @click="changeCredential(item)" :title="$t('ui.edit')")  
                  a.fa.fa-edit.btn.btn-ssm.btn-icon.btn-info(v-if="item.payment_mode != 'MANUAL'" href="javascript:void(0)" @click="isEditAccess ? changeCredential(item) : null" :title="$t('ui.edit')" :disabled="!isEditAccess")  

    updatepaymentoptionstatus(ref="updatepaymentoptionstatus" :item="editSelectedPaymentMode"  @clicked="afterPaymentOptionUpdateStatus" @closed="afterPaymentOptionUpdateStatus" @failed="handleFailed")
    updatepaymentoptioncredential(ref="updatepaymentoptioncredential" :item="editSelectedPaymentMode"  @clicked="afterPaymentOptionCredential" @failed="handleFailed")
    updatepaymentoptionlimit(ref="updatepaymentoptionlimit" :item="editSelectedPaymentMode"  @clicked="afterPaymentOptionLimit" @failed="handleFailed")
    updatepaymentoptionvip(ref="updatepaymentoptionvip" :item="editSelectedPaymentMode"  @clicked="afterPaymentOptionVip" @failed="handleFailed")
    updatepaymentoptiondesc(ref="updatepaymentoptiondesc" :item="editSelectedPaymentMode"  @clicked="afterPaymentOptionDesc" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import updatepaymentoptionstatus from "@/components/globalsetting/updatePaymentOptionStatus.vue";
import updatepaymentoptioncredential from "@/components/globalsetting/updatePaymentOptionCredential.vue";
import updatepaymentoptionlimit from "@/components/globalsetting/updatePaymentOptionLimit.vue";
import updatepaymentoptionvip from "@/components/globalsetting/updatePaymentOptionVip.vue";
import updatepaymentoptiondesc from "@/components/globalsetting/updatePaymentOptionDesc.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    updatepaymentoptionstatus,
    updatepaymentoptioncredential,
    updatepaymentoptionlimit,
    updatepaymentoptionvip,
    updatepaymentoptiondesc
  },
  data: () => ({
    loading: false,
    paymentOptionList: [],
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    editSelectedPaymentMode: null,
    maxSeq: 0
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
    isEditAccess() {
      return this.$helpers.showActionButton("e_paymentoption");
    },
    paymentOptionListLength() {
      if (this.paymentOptionList) {
        if(this.maxSeq > this.paymentOptionList.length) {
          return this.maxSeq;
        } else {
          return this.paymentOptionList.length;
        }
      } else {
        return 0;
      }
    },
  },
  mounted: function() {  },
  methods: {
    refresh() {
      this.getPaymentOptionList();
    },
    getPaymentOptionList: function() {
      let url = config.paymentOptionListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.paymentOptionList = response.data.dt;
                if(this.paymentOptionList.length > 0) {
                  // Filter out objects with seq < 100, then find the max seq value
                  const maxSeq = this.paymentOptionList
                    .filter(item => item.seq < 100) // Keep only items with seq < 100
                    .reduce((max, item) => Math.max(max, item.seq), -Infinity); // Find the maximum seq

                  this.maxSeq = maxSeq;
                } else {
                  this.maxSeq = 0;
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedStatus: function(item, eventStatus) {
      if(item.status && item.payment_mode != 'MANUAL') {
        if(item.credential_1) {
          this.editSelectedPaymentMode = item
          this.$refs.updatepaymentoptionstatus.$refs.updatePaymentOptionStatus.show();
        } else {
          eventStatus.srcElement.checked = !item.status;
          item.status = !item.status;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.credentialNotSet"), "error");
        }
      } else {
        this.$helpers
          .alert({
            title: this.$t("ui.status"),
            text: this.$t("message.change_payment_mode_status_confirm", { name: item.payment_mode }),
            type: "question",
            showCancelButton: true
          })
          .then(result => {
            if (result.value) {
              this.confirmStatus(item, eventStatus.srcElement.checked);
            } else {
              eventStatus.srcElement.checked = !item.status;
              item.status = !item.status;
            }
          });
      }
    },
    confirmStatus: function(item, status) {
      let url = config.paymentOptionUpdateStatusUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        payment_mode: item.payment_mode,
        new_status: status
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.combine.change_payment_mode_status"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
              this.getPaymentOptionList();
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedSeq: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_payment_mode_seq_confirm", { mode: item.payment_mode }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmSeq(item, eventStatus);
          } else {
            this.getPaymentOptionList();
          }
        });
    },
    confirmSeq: function(item, seq) {
      let url = config.paymentOptionUpdateSeqUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        payment_mode: item.payment_mode,
        seq: seq
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.getPaymentOptionList();
                this.$helpers.showDialog(this.$t("ui.change_payment_option_seq"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                this.getPaymentOptionList();
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    changedRecommend: function(item, eventStatus) {
      this.$helpers
        .alert({
          title: this.$t("ui.status"),
          text: this.$t("message.change_payment_option_recommend_confirm", { mode: item.payment_mode, group: item.bank_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmRecommend(item, eventStatus.srcElement.checked);
          } else {
            eventStatus.srcElement.checked = !item.is_recommend;
            item.is_recommend = !item.is_recommend;
          }
        });
    },
    confirmRecommend: function(item, status) {
      let url = config.paymentOptionUpdateRecommendUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        payment_mode: item.payment_mode,
        is_recommend: status
      };

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$helpers.showDialog(this.$t("ui.combine.change_payment_option_recommend"), this.$t("message.success"), "success");
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
              this.getPaymentOptionList();
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changeCredential: function(item) {
      this.editSelectedPaymentMode = item
      this.$refs.updatepaymentoptioncredential.$refs.updatePaymentOptionCredential.show();
    },
    changeLimit: function(item) {
      this.editSelectedPaymentMode = item
      this.$refs.updatepaymentoptionlimit.$refs.updatePaymentOptionLimit.show();
    },
    changeVip: function(item) {
      this.editSelectedPaymentMode = item
      this.$refs.updatepaymentoptionvip.$refs.updatePaymentOptionVip.show();
    },
    changeDesc: function(e) {
      this.editSelectedPaymentMode = e;
      this.$refs.updatepaymentoptiondesc.$refs.updatePaymentOptionDesc.show();
    },
    afterPaymentOptionUpdateStatus(mode) {
      this.getPaymentOptionList();
      if(!mode){
        this.$helpers.showDialog(this.$t("ui.combine.change_payment_mode_status"), this.$t("message.success"), "success");
      }
    },
    afterPaymentOptionCredential() {
      this.getPaymentOptionList();
      this.$helpers.showDialog(this.$t("ui.combine.change_payment_option_credential"), this.$t("message.success"), "success");
    },
    afterPaymentOptionLimit() {
      this.getPaymentOptionList();
      this.$helpers.showDialog(this.$t("ui.combine.change_payment_option_limit"), this.$t("message.success"), "success");
    },
    afterPaymentOptionVip() {
      this.getPaymentOptionList();
      this.$helpers.showDialog(this.$t("ui.combine.change_payment_option_vip"), this.$t("message.success"), "success");
    },
    afterPaymentOptionDesc: function() {
      this.getPaymentOptionList();
      this.$helpers.showDialog(this.$t("ui.combine.change_payment_option_desc"), this.$t("message.success"), "success");
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>